import Role from './role';
import { type } from '../core/serialization';

export default class Staff {
  id: string = null;
  emailAddress: string = null;
  invitationStatus: string = null;
  @type(Role) roles: Role[] = [];
}
